import axiosService from "@/modules/axios-service";

class BankListService {
  async select(path, requestBody) {
    return await axiosService.post(path, requestBody);
  }
}

export default new BankListService();
